import { DashValidation, isEmailValid, isEmptyOrNil, isNameLengthValid } from 'dash-common';
import { FormContext, FormErrorTypes } from 'dash-ui';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/constants/constants';

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  const validateFieldByName = (
    fieldName: FormFields,
    value: string | Array<{ _id: string }>
  ) => {
    const setInvalid = (message: string, values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message, values || {}),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.FirstName:
      case FormFields.LastName: {
        if (isEmptyOrNil(value as string)) {
          setInvalid(
            fieldName === FormFields.FirstName
              ? 'forms:messages.firstNameBlank'
              : 'forms:messages.lastNameBlank'
          );
          return false;
        }
        if (!isNameLengthValid(value as string)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.Email: {
        if (!isEmailValid(value as string)) {
          setInvalid('forms:messages.emailInvalid');
          return false;
        }
        break;
      }
      case FormFields.Role: {
        if (!value) {
          setInvalid('forms:messages.roleBlank');
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
